export default __webpack_public_path__ + "static/media/1402.53d6a57a.png";